export default __webpack_public_path__ + "static/media/lemon.5f7bc5d2.png";